import { Pencil } from 'lucide-react-native';
import { Pressable } from 'react-native';

import { ProfileSectionTitle } from '@/components/profile/ProfileText';
import { HStack } from '@/components/ui/hstack';
import { Icon } from '@/components/ui/icon';

interface ProfileSectionHeaderProps {
  title: string;
  isOwnProfile?: boolean;
  onEdit?: () => void;
}

/**
 * Shared header for the editable bio sections (About, Work History, Education,
 * Disclosures): the section title plus an edit affordance shown only on the
 * owner's own profile. Centralised so the four sections' headers cannot drift
 * in layout, spacing, or the edit control. See `.claude/rules/profile.md`.
 */
export function ProfileSectionHeader({ title, isOwnProfile, onEdit }: ProfileSectionHeaderProps) {
  return (
    <HStack className="mx-auto mb-3 w-full max-w-5xl items-center justify-between px-6">
      <ProfileSectionTitle className="text-left">{title}</ProfileSectionTitle>
      {isOwnProfile ? (
        <Pressable
          hitSlop={{ top: 15, bottom: 15, left: 15, right: 15 }}
          onPress={onEdit}
          className="p-2">
          <Icon as={Pencil} size="md" className="text-primary-600" />
        </Pressable>
      ) : null}
    </HStack>
  );
}
